<template>

    <transition name="from-right">
      <div class="sign-modal-wrapper" v-if="this.$store.state.main.signActive">
        <div class="auth-wrapper" v-if="authActive">
          <div class="upper-wrapper">
            <div class="close-wrapper">
              <svg
                id="j-logo-modal"
                xmlns="http://www.w3.org/2000/svg"
                width="59.999"
                height="60"
                viewBox="0 0 59.999 60"
              >
                <g
                  id="Group_99"
                  data-name="Group 99"
                  transform="translate(-692.335 -235.632)"
                >
                  <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                    transform="translate(0 0)"
                    fill="#bacb32"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                    transform="translate(3.137 2.015)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <div class="close-btn" @click="openSignModal()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.469"
                  height="27.766"
                  viewBox="0 0 26.469 27.766"
                >
                  <g
                    id="Group_240"
                    data-name="Group 240"
                    transform="translate(-1721.922 -107.326)"
                  >
                    <path
                      id="Path_1643"
                      data-name="Path 1643"
                      d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                      transform="translate(1725.181 107.326) rotate(45)"
                      fill="#101820"
                    />
                    <path
                      id="Path_1644"
                      data-name="Path 1644"
                      d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                      transform="translate(1721.922 131.48) rotate(-45)"
                      fill="#101820"
                    />
                  </g>
                </svg>

                <span class="f-21 regular">
                  {{ $fn.tr("დახურვა") }}
                </span>
              </div>
            </div>
            <div class="sign-modal-inner">
              <h2 class="f-34">{{ $fn.tr("ავტორიზაცია") }}</h2>

              <div class="social-sign-btns">
                  <router-link
                  class="google-btn"
                  @click="login_fb();"
                  :to=" '/source/api/fb/redirect'"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.001"
                    height="22"
                    viewBox="0 0 11.001 22"
                  >
                    <path
                      id="facebook"
                      d="M15.179,3.653h2.008V.155A25.934,25.934,0,0,0,14.262,0c-2.9,0-4.879,1.821-4.879,5.169V8.25h-3.2v3.911h3.2V22H13.3V12.161h3.066l.487-3.91H13.3V5.557c0-1.13.305-1.9,1.88-1.9Z"
                      transform="translate(-6.187)"
                      fill="#fff"
                    />
                  </svg>
                  <span class="bold f-16">Faceboook</span>
                </router-link>
                <router-link
                  class="google-btn"
                  :to="'/source/api/google/redirect'"
                  @click="login_google();"
                  target="_blank"
                >
                  <svg
                    id="search"
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                  >
                    <path
                      id="Path_3920"
                      data-name="Path 3920"
                      d="M4.876,145.622,4.11,148.48l-2.8.059a11.019,11.019,0,0,1-.081-10.272h0l2.492.457L4.814,141.2a6.565,6.565,0,0,0,.062,4.42Z"
                      transform="translate(0 -132.327)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3921"
                      data-name="Path 3921"
                      d="M272.194,208.176a11,11,0,0,1-3.921,10.633h0l-3.139-.16-.444-2.773a6.556,6.556,0,0,0,2.821-3.348h-5.882v-4.352h10.566Z"
                      transform="translate(-250.386 -199.231)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3922"
                      data-name="Path 3922"
                      d="M47.084,315.692h0a11,11,0,0,1-16.576-3.365l3.565-2.918a6.542,6.542,0,0,0,9.427,3.35Z"
                      transform="translate(-29.198 -296.114)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3923"
                      data-name="Path 3923"
                      d="M45.415,2.532,41.852,5.45a6.541,6.541,0,0,0-9.644,3.425L28.625,5.941h0A11,11,0,0,1,45.415,2.532Z"
                      transform="translate(-27.394)"
                      fill="#fff"
                    />
                  </svg>

                  <span class="bold f-16">Google</span>
                </router-link>
              </div>
              <div class="or">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="256"
                  height="1"
                  viewBox="0 0 256 1"
                >
                  <line
                    id="Line_143"
                    data-name="Line 143"
                    x2="256"
                    transform="translate(0 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>

                <span class="f-16 light-italic">{{ $fn.tr("ან") }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="256"
                  height="1"
                  viewBox="0 0 256 1"
                >
                  <line
                    id="Line_143"
                    data-name="Line 143"
                    x2="256"
                    transform="translate(0 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </div>
              <div class="err-block">
                <transition name="fade">
                  <errorBlock
                    v-if="userError"
                    :text="$fn.tr('ელ. ფოსტა ან პაროლი არასწორია')"
                  />
                </transition>
              </div>
              <el-form
                :model="authform"
                :rules="authrules"
                ref="authform"
                class="contact-form"
                autocomplete="off"
              >
                <el-form-item prop="inputmail">
                  <p class="f-21 bold-italic place__holder" :class="{ err: userError }">{{$fn.tr('ელ.ფოსტა')}}</p>
                  <el-input
                       @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"
                    v-model="authform.inputmail"
                    type="email"
                    class="signinmail"
                    :class="{ err: userError }"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputpass">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError }">{{$fn.tr('პაროლი')}}</p>

                  <el-input
                    @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"
                    v-model="authform.inputpass"
                    type="password"
                    class="signinpass"
                    :class="{ err: userError }"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <div class="forgot-pass" @click="openForgotPass()">
                  <span class="f-13 light-italic">{{
                    $fn.tr("დაგავიწყდა პაროლი?")
                  }}</span>
                </div>
                <button
                  class="auth-btn"
                  @click.prevent="
                    authorize();
                
                  "
                >
                  <span class="f-21 regular">{{ $fn.tr("Sign in") }}</span>
                </button>
              </el-form>
            </div>
          </div>
          <div class="sign-modal-footer">
            <span class="f-16 light-italic">{{
              $fn.tr("არ გაქვს შექმნილი ანგარიში?")
            }}</span>
            <span class="f-21 bold-italic" @click="openReg">{{
              $fn.tr("რეგისტრაცია")
            }}</span>
          </div>
        </div>

        <div class="auth-wrapper forgot-password" v-if="forgotActive">
          <div class="upper-wrapper">
            <div class="close-wrapper">
              <svg
                id="j-logo-modal"
                xmlns="http://www.w3.org/2000/svg"
                width="59.999"
                height="60"
                viewBox="0 0 59.999 60"
              >
                <g
                  id="Group_99"
                  data-name="Group 99"
                  transform="translate(-692.335 -235.632)"
                >
                  <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                    transform="translate(0 0)"
                    fill="#bacb32"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                    transform="translate(3.137 2.015)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <div class="close-btn" @click="openSignModal()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.469"
                  height="27.766"
                  viewBox="0 0 26.469 27.766"
                >
                  <g
                    id="Group_240"
                    data-name="Group 240"
                    transform="translate(-1721.922 -107.326)"
                  >
                    <path
                      id="Path_1643"
                      data-name="Path 1643"
                      d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                      transform="translate(1725.181 107.326) rotate(45)"
                      fill="#101820"
                    />
                    <path
                      id="Path_1644"
                      data-name="Path 1644"
                      d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                      transform="translate(1721.922 131.48) rotate(-45)"
                      fill="#101820"
                    />
                  </g>
                </svg>

                <span class="f-21 regular">
                  {{ $fn.tr("დახურვა") }}
                </span>
              </div>
            </div>
            <div class="sign-modal-inner">
              <h2 class="f-34">{{ $fn.tr("პაროლის აღდგენა") }}</h2>

              <div class="err-block">
                <transition name="fade">
                  <errorBlock
                    v-if="userError2"
                    :text="$fn.tr('ელ. ფოსტა ან ნომერი არასწორია')"
                  />
                </transition>
              </div>
              <el-form
                :model="forgotform"
                :rules="forgotrules"
                ref="forgotform"
                class="contact-form"
                 autocomplete="off"
              >
                <el-form-item prop="inputmailf">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError2 }">{{$fn.tr('ელ.ფოსტა')}}</p>

                  <el-input
                    @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model="forgotform.inputmailf"
                    type="email"
                    class="signinmail"
                    :class="{ err: userError2 }"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputphonef">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError2 }">{{$fn.tr('ტელ.ნომერი')}}</p>

                  <el-input
                  @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model.number="forgotform.inputphonef"
                    class="signinpass"
                    :class="{ err: userError2 }"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <button class="auth-btn" @click.prevent="checkForgotPass()">
                  <span class="f-21 regular">{{
                    $fn.tr("Restore")
                  }}</span>
                </button>

          <span class="f-21 bold-italic forgot_success_message" v-if="forgot_success_message">{{ $fn.tr('ახალი პაროლი გამოიგზავნა მითითებულ ნომერზე') }}</span>
          <span class="f-21 bold-italic forgot_success_message" v-if="user_not_found">{{ $fn.tr('მომხმარებელი არ მოიძებნა') }}</span>

              </el-form>
            </div>
          </div>
          <div class="sign-modal-footer">
            <span class="f-16 light-italic">{{
              $fn.tr("არ გაქვს შექმნილი ანგარიში?")
            }}</span>
            <span class="f-21 bold-italic" @click="openRegFromForgot">{{
              $fn.tr("რეგისტრაცია")
            }}</span>
            <span class="f-16 light-italic">{{
              $fn.tr("გაქვს ანგარიში?")
            }}</span>
            <span class="f-21 bold-italic" @click="openAuthFromForgot">{{
              $fn.tr("ავტორიზაცია")
            }}</span>
          </div>
        </div>

        <div class="reg-wrapper" v-if="regActive">
          <div class="upper-wrapper">
            <div class="close-wrapper">
              <svg
                id="j-logo-modal"
                xmlns="http://www.w3.org/2000/svg"
                width="59.999"
                height="60"
                viewBox="0 0 59.999 60"
              >
                <g
                  id="Group_99"
                  data-name="Group 99"
                  transform="translate(-692.335 -235.632)"
                >
                  <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                    transform="translate(0 0)"
                    fill="#bacb32"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                    transform="translate(3.137 2.015)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <div class="close-btn" @click="openSignModal()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.469"
                  height="27.766"
                  viewBox="0 0 26.469 27.766"
                >
                  <g
                    id="Group_240"
                    data-name="Group 240"
                    transform="translate(-1721.922 -107.326)"
                  >
                    <path
                      id="Path_1643"
                      data-name="Path 1643"
                      d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                      transform="translate(1725.181 107.326) rotate(45)"
                      fill="#101820"
                    />
                    <path
                      id="Path_1644"
                      data-name="Path 1644"
                      d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                      transform="translate(1721.922 131.48) rotate(-45)"
                      fill="#101820"
                    />
                  </g>
                </svg>

                <span class="f-21 regular">
                  {{ $fn.tr("დახურვა") }}
                </span>
              </div>
            </div>
            <div class="sign-modal-inner">
              <h2 class="f-34">{{ $fn.tr("რეგისტრაცია") }}</h2>

              <div class="social-sign-btns">
                <div class="fb-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.001"
                    height="22"
                    viewBox="0 0 11.001 22"
                  >
                    <path
                      id="facebook"
                      d="M15.179,3.653h2.008V.155A25.934,25.934,0,0,0,14.262,0c-2.9,0-4.879,1.821-4.879,5.169V8.25h-3.2v3.911h3.2V22H13.3V12.161h3.066l.487-3.91H13.3V5.557c0-1.13.305-1.9,1.88-1.9Z"
                      transform="translate(-6.187)"
                      fill="#fff"
                    />
                  </svg>
                  <span class="bold f-16">Facebook</span>
                </div>
                <div class="google-btn">
                  <svg
                    id="search"
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                  >
                    <path
                      id="Path_3920"
                      data-name="Path 3920"
                      d="M4.876,145.622,4.11,148.48l-2.8.059a11.019,11.019,0,0,1-.081-10.272h0l2.492.457L4.814,141.2a6.565,6.565,0,0,0,.062,4.42Z"
                      transform="translate(0 -132.327)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3921"
                      data-name="Path 3921"
                      d="M272.194,208.176a11,11,0,0,1-3.921,10.633h0l-3.139-.16-.444-2.773a6.556,6.556,0,0,0,2.821-3.348h-5.882v-4.352h10.566Z"
                      transform="translate(-250.386 -199.231)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3922"
                      data-name="Path 3922"
                      d="M47.084,315.692h0a11,11,0,0,1-16.576-3.365l3.565-2.918a6.542,6.542,0,0,0,9.427,3.35Z"
                      transform="translate(-29.198 -296.114)"
                      fill="#fff"
                    />
                    <path
                      id="Path_3923"
                      data-name="Path 3923"
                      d="M45.415,2.532,41.852,5.45a6.541,6.541,0,0,0-9.644,3.425L28.625,5.941h0A11,11,0,0,1,45.415,2.532Z"
                      transform="translate(-27.394)"
                      fill="#fff"
                    />
                  </svg>

                  <span class="bold f-16">Google</span>
                </div>
              </div>
              <div class="or">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="256"
                  height="1"
                  viewBox="0 0 256 1"
                >
                  <line
                    id="Line_143"
                    data-name="Line 143"
                    x2="256"
                    transform="translate(0 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>

                <span class="f-16 light-italic">{{ $fn.tr("ან") }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="256"
                  height="1"
                  viewBox="0 0 256 1"
                >
                  <line
                    id="Line_143"
                    data-name="Line 143"
                    x2="256"
                    transform="translate(0 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </div>
              <div class="sms-sent" v-if="email_exists">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g
                    id="Group_3311"
                    data-name="Group 3311"
                    transform="translate(-1315 -328)"
                  >
                    <path
                      id="Path_3937"
                      data-name="Path 3937"
                      d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z"
                      transform="translate(1315 328)"
                      fill="#fff"
                    />
                  </g>
                </svg>

                <span class="f-21 light-italic">{{
                  $fn.tr("ასეთი იმეილით მომხმარებელი უკვე რეგისტრირებულია")
                }}</span>
              </div>

              <el-form
                :model="regform"
                :rules="regrules"
                ref="regform"
                class="contact-form"
                 autocomplete="off"
              >
                <el-form-item prop="inputregname">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError3 }">{{$fn.tr('სახელი *')}}</p>

                  <el-input
                        @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model="regform.inputregname"
                    type="text"
                    class="signinpass"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputlastname">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError3 }">{{$fn.tr('გვარი *')}}</p>

                  <el-input
                      @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model="regform.inputlastname"
                    type="text"
                    class="signinpass"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputregmail">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError3 }">{{$fn.tr('ელ.ფოსტა *')}}</p>

                  <el-input
                      @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model="regform.inputregmail"
                    type="email"
                    class="signinmail"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputphone">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError3 }">{{$fn.tr('ტელ.ნომერი *')}}</p>

                  <el-input
                      @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)"  
                    v-model.number="regform.inputphone"
                    class="signinpass"
                  ></el-input>
                </el-form-item>

                <div class="tool-tip-row">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  >
                    <path
                      id="Path_3847"
                      data-name="Path 3847"
                      d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z"
                      fill="#fff"
                    />
                  </svg>
                  <span class="f-16 light-italic">{{
                    $fn.tr("ვერიფიკაციისთვის ნომერზე გამოგეგზავნებათ SMS კოდი")
                  }}</span>
                </div>
            <div class="ag-checkbox-wrapper">
                     <el-form-item prop="checked">
                  <el-checkbox v-model="regform.checked"
                    >
                  </el-checkbox>
                </el-form-item>
            <span class="f-16 light-italic">  {{ $fn.tr("ვეთანხმები საიტის") }}</span>
                    <router-link :to="this.getPrivacyLink[0].full_url">{{ $fn.tr("წესებს") }}</router-link>
            </div>
                <span class="f-21 bold-italic forgot_success_message" v-if="this.user_phone_exists == 'User With this phone exists'">{{$fn.tr('მომხმარებელი ამ ნომრით უკვე არსებობს')}}</span>

              </el-form>

              <div class="auth-btn">
                <span
                  class="f-21 regular"
                  @click="
                    register();
                    
                  "
                  >{{ $fn.tr("გაგრძელება") }}</span
                >
              </div>
            </div>
          </div>
          <div class="sign-modal-footer">
            <span class="f-16 light-italic">{{
              $fn.tr("გაქვს ანგარიში?")
            }}</span>
            <span class="f-21 bold-italic" @click="openReg">{{
              $fn.tr("ავტორიზაცია")
            }}</span>
          </div>
        </div>

        <div class="reg-wrapper" v-if="regActiveTwo">
          <div class="upper-wrapper">
            <div class="close-wrapper">
              <svg
                id="j-logo-modal"
                xmlns="http://www.w3.org/2000/svg"
                width="59.999"
                height="60"
                viewBox="0 0 59.999 60"
              >
                <g
                  id="Group_99"
                  data-name="Group 99"
                  transform="translate(-692.335 -235.632)"
                >
                  <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                    transform="translate(0 0)"
                    fill="#bacb32"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                    transform="translate(3.137 2.015)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <div class="close-btn" @click="openSignModal()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.469"
                  height="27.766"
                  viewBox="0 0 26.469 27.766"
                >
                  <g
                    id="Group_240"
                    data-name="Group 240"
                    transform="translate(-1721.922 -107.326)"
                  >
                    <path
                      id="Path_1643"
                      data-name="Path 1643"
                      d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                      transform="translate(1725.181 107.326) rotate(45)"
                      fill="#101820"
                    />
                    <path
                      id="Path_1644"
                      data-name="Path 1644"
                      d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                      transform="translate(1721.922 131.48) rotate(-45)"
                      fill="#101820"
                    />
                  </g>
                </svg>

                <span class="f-21 regular">
                  {{ $fn.tr("დახურვა") }}
                </span>
              </div>
            </div>
            <div class="sign-modal-inner">
              <h2 class="f-34">{{ $fn.tr("რეგისტრაცია") }}</h2>

              <div class="sms-sent">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g
                    id="Group_3311"
                    data-name="Group 3311"
                    transform="translate(-1315 -328)"
                  >
                    <path
                      id="Path_3937"
                      data-name="Path 3937"
                      d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z"
                      transform="translate(1315 328)"
                      fill="#fff"
                    />
                  </g>
                </svg>

                <span class="f-21 light-italic">{{
                  $fn.tr("SMS კოდი გამოგზავნილია მითითებულ ნომერზე")
                }}</span>
              </div>
              <span class="resend f-16 light-italic" @click="resend()">{{
                $fn.tr("SMS კოდის თავიდან გამოგზავნა")
              }}</span>
              <el-form
                :model="regform2"
                :rules="regrules2"
                ref="regform2"
                class="contact-form"
                 autocomplete="off"
              >
                <el-form-item prop="code">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError4 }">{{$fn.tr('შეიყვანე კოდი *')}}</p>
                  
                  <el-input
                    @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)" 
                    v-model.number="regform2.code"
                    class="signinpass"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="pass">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError4 }">{{$fn.tr('პაროლი *')}}</p>

                  <el-input
                       @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)" 
                    v-model="regform2.pass"
                    type="password"
                    class="signinpass"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="passconfirm">
                  <p class="f-21 bold-italic place__holder"  :class="{ err: userError4 }">{{$fn.tr('გაიმეორე პაროლი *')}}</p>

                  <el-input
                       @focus="moveUpPH($event)"
                    @blur="moveDownPH($event)" 
                    v-model="regform2.passconfirm"
                    type="password"
                    class="signinmail"
                  ></el-input>
                </el-form-item>

                    <span class="f-21 bold-italic forgot_success_message" v-if="wrong_code">{{$fn.tr('შეყვანილი კოდი არასწორია') }}</span>
              </el-form>

              <div class="auth-btn">
                <span class="f-21 regular" @click="register2()">{{
                  $fn.tr("რეგისტრაცია")
                }}</span>
              </div>
            </div>
          </div>
          <div class="sign-modal-footer">
            <span class="f-16 light-italic">{{
              $fn.tr("გაქვს ანგარიში?")
            }}</span>
            <span class="f-21 bold-italic" @click="openReg">{{
              $fn.tr("ავტორიზაცია")
            }}</span>

          </div>
        </div>
      </div>
    </transition>
 
</template>

<script>
import errorBlock from "@/components/smartComponents/errorBlock.vue";
export default {
  components: {
    errorBlock
  },
  props: ["slide"],

  data() {
    var checkEmail = (rule, value, callback) => {
      if (value === "") {
        this.userError = true;
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ელ.ფოსტა")));
        
      } else if (!value.includes("@")) {
         this.userError = true;
        callback(new Error(this.$fn.tr("ელ.ფოსტა უნდა შეიცავდეს სიმბოლო @-ს")));
      } else {
         this.userError = false;
        console.log("correct");
        callback();
      }
    };

    var checkEmail2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ელ.ფოსტა")));
      } else if (!value.includes("@")) {
        callback(new Error(this.$fn.tr("ელ.ფოსტა უნდა შეიცავდეს სიმბოლო @-ს")));
      } else {
        console.log("correct");
        callback();
      }
    };

    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ პაროლი")));
      } else {
        console.log("correct");
        callback();
      }
    };

    var checkRegName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ სახელი")));
      } else {
        console.log("correct");
        callback();
      }
    };

    var checkLastName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ გვარი")));
      } else {
        console.log("correct");
        callback();
      }
    };

    var checkRegEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ელ.ფოსტა")));
      } else if (!value.includes("@")) {
        callback(new Error(this.$fn.tr("ელ.ფოსტა უნდა შეიცავდეს სიმბოლო @-ს")));
      } else {
        console.log("correct");
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ნომერი")));
      }

      if (!Number.isInteger(value)) {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
      } else {
        callback();
      }
    };

    var checkCheckbox = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.$fn.tr("გთხოვთ დაეთანხმოთ საიტის წესებს"))
        );
      } else {
        callback();
      }
    };

    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ კოდი")));
      }

      if (!Number.isInteger(value)) {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
      } else {
        callback();
      }
    };

    var checkPhoneForgot = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ტელ. ნომერი")));
      }

      if (!Number.isInteger(value)) {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
      } else {
        callback();
      }
    };

    var checkPass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ პაროლი")));
      } else if (value.length < 6) {
        return callback(
          new Error(this.$fn.tr("პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს"))
        );
      } else {
        callback();
      }
    };

    var checkPassConfirm = (rule, value, callback) => {
      if (value !== this.regform2.pass) {
        return callback(
          new Error(this.$fn.tr("პაროლები ერთმანეთს არ ემთხვევა"))
        );
      } else {
        callback();
      }
    };
    return {
      userError: false,
      userError2: false,
      userError3: false,
      userError4: false,
      email_exists: false,
      wrong_code: false,
      forgot_success_message: false,
      user_not_found: false,
      user_phone_exists: '',
      loc_origin: window.location.origin,
      user_token: "",
      authform: {
        inputmail: "",
        inputpass: ""
      },
      regform: {
        inputregmail: "",
        inputregname: "",
        inputlastname: "",
        checked: true,
        inputphone: ""
      },
      regform2: {
        code: "",
        pass: "",
        passconfirm: ""
      },

      forgotform: {
        inputmailf: "",
        inputphonef: ""
      },

      authActive: true,
      regActive: false,
      regActiveTwo: false,
      forgotActive: false,
      forgotrules: {
        inputmailf: [
          {
            required: true,
            validator: checkEmail2,
            trigger: this.checkForgotPass
          }
        ],
        inputphonef: [
          {
            required: true,
            validator: checkPhoneForgot,
            trigger: this.checkForgotPass
          }
        ]
      },
      authrules: {
        inputmail: [
          { required: true, validator: checkEmail, trigger: this.authorize }
        ],
        inputpass: [
          { required: true, validator: checkName, trigger: this.authorize }
        ]
      },
      regrules: {
        inputregmail: [
          { required: true, validator: checkRegEmail, trigger: this.register }
        ],
        inputregname: [
          { required: true, validator: checkRegName, trigger: this.register }
        ],
        inputlastname: [
          { required: true, validator: checkLastName, trigger: this.register }
        ],
        inputphone: [
          { required: true, validator: checkPhone, trigger: this.register }
        ],

        checked: [
          { required: true, validator: checkCheckbox, trigger: this.register }
        ]
      },

      regrules2: {
        code: [
          { required: true, validator: checkCode, trigger: this.register2 }
        ],
        pass: [
          { required: true, validator: checkPass, trigger: this.register2 }
        ],
        passconfirm: [
          {
            required: true,
            validator: checkPassConfirm,
            trigger: this.register2
          }
        ]
      }
    };
  },
  computed: {
    callRegister() {
      return this.$store.state.main.callRegister;
    },
    signActive(){
      return this.$store.state.main.signActive;
    },
     getPrivacyLink(){
          return this.$store.state.main.indx.menus.filter(p => p.url_slug === 'privacy-policy')
        },
  },
  mounted() {},
  watch: {
    callRegister(ns, os) {
      this.openSignModal();
      this.openReg();
      console.log(this.regActive);
      this.authActive = false;
      this.regActive = true;
    },
    signActive(){
             if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if(this.$refs.forgotform) this.$refs.forgotform.resetFields();
    },
    
      // authActive: true,
      // regActive: false,
      // regActiveTwo: false,
      // forgotActive: false,
    authActive(ns, os){
         document.querySelectorAll(".place__holder").forEach(holder => {
            holder.style.transform = "translateY(100%)";
                 console.log(holder.parentElement)
          })
     
                if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if(this.$refs.forgotform) this.$refs.forgotform.resetFields();

    },
     regActive(ns, os){
         document.querySelectorAll(".place__holder").forEach(holder => {
            //  console.log()
            
          //  holder.parentElement.querySelector('input').value == '' ?  holder.style.transform = "translateY(100%)"  :   holder.style.transform = "translateY(0%)";
             holder.style.transform = "translateY(100%)";
           console.log(holder.parentElement.querySelector('input').value)
          })
             if (this.$refs.authform) this.$refs.authform.resetFields();
      // if (this.$refs.regform) this.$refs.regform.resetFields();
      // if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if(this.$refs.forgotform) this.$refs.forgotform.resetFields();
    },
     regActiveTwo(ns, os){
         document.querySelectorAll(".place__holder").forEach(holder => {
            holder.style.transform = "translateY(100%)";
          })
             if (this.$refs.authform) this.$refs.authform.resetFields();
      // if (this.$refs.regform) this.$refs.regform.resetFields();
      // if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if(this.$refs.forgotform) this.$refs.forgotform.resetFields();

    },
     forgotActive(ns, os){
         document.querySelectorAll(".place__holder").forEach(holder => {
            holder.style.transform = "translateY(100%)";
          })
             if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if(this.$refs.forgotform) this.$refs.forgotform.resetFields();

    },

  },
  methods: {
    login_fb(){
      // this.$router.push( '/source/api/fb/redirect');
      console.log(this.$route)
      // console.log( window.location.origin)
    },
    moveUpPH(e){
      let p = e.target.parentElement.parentElement;
      let ph = p.querySelector(".place__holder");
      ph.style.transform = "translateY(0)";
    // e.target.value !== '' ? ph.style.transform = "translateY(0)" : ph.style.transform = "translateY(0%)";

    },
    moveDownPH(e){
      
      let p = e.target.parentElement.parentElement;
      let ph = p.querySelector(".place__holder");
    e.target.value !== '' ? ph.style.transform = "translateY(0%)" : ph.style.transform = "translateY(100%)";

    },
    async sendForgotPass() {
      console.log("heeeeey");
      //  if (tmp.status === 201) {
      //   this.userError2 = true;
      // } else {
      //   this.userError2 = false;
      // }
      // user/updatepassword 

         let data = {};
     
      data.email = this.forgotform.inputmailf;
      data.phone = this.forgotform.inputphonef;


      let tmp = await this.$fn.postData("user/updatepassword", data);
      if (tmp.status == 200 && tmp.data.message !== 'no user found with this credentials') {
        this.user_not_found = false;
         this.forgot_success_message = true; 
         
          this.$refs.forgotform.resetFields();
      } else {
        this.forgot_success_message = false; 
        this.user_not_found = true;
      }
      console.log(tmp)
    },
    checkForgotPass() {
      this.$refs.forgotform.validate(valid => {
        if (valid) {
          this.sendForgotPass();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetUserErrors(){
          this.userError = false;
      this.userError2 = false;
      this.userError3 = false;
      this.userError4 = false;
      this.forgot_success_message = false; 
      this.user_not_found = false;

    },
    openRegFromForgot() {
      this.forgotActive = false;
      this.regActive = true;
      if (this.$refs.forgotform) this.$refs.forgotform.resetFields();
      this.forgot_success_message = false; 
      this.user_not_found = false;
      
    },
    openAuthFromForgot() {
      this.forgotActive = false;
      this.authActive = true;
      if (this.$refs.forgotform) this.$refs.forgotform.resetFields();
      this.forgot_success_message = false; 
      this.user_not_found = false;

    },
    openSignModal() {
      this.$store.commit("main/signStatus", !this.$store.state.main.signActive);
            setTimeout(() => {
           if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if (this.$refs.regform) this.regform.inputregmail = '';
      if (this.$refs.regform) this.regform.inputphone = '';
      console.log(this.$refs.regform)

      }, 100);
    },
    openForgotPass() {
      this.authActive = false;
      this.regActive = false;
      this.regActiveTwo = false;
      this.forgotActive = true;

      if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      this.forgot_success_message = false; 

      this.resetUserErrors();
    },
    openReg() {
      this.forgot_success_message = false; 
      this.user_not_found = false;

      if (this.authActive && !this.regActive) {
        this.authActive = false;
        this.regActive = true;
      } else if (this.regActive && !this.authActive) {
        this.authActive = true;
        this.regActive = false;
      } else if (this.regActiveTwo && !this.regActive && !this.authActive) {
        this.regActiveTwo = false;
        this.authActive = true;
      } 
      this.resetUserErrors();
      setTimeout(() => {
           if (this.$refs.authform) this.$refs.authform.resetFields();
      if (this.$refs.regform) this.$refs.regform.resetFields();
      if (this.$refs.regform2) this.$refs.regform2.resetFields();
      if (this.$refs.regform) this.regform.inputregmail = '';
      if (this.$refs.regform) this.regform.inputphone = '';
      console.log(this.$refs.regform)

      }, 20);
     
    },
    authorize() {
      this.$refs.authform.validate(valid => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },

    register() {
      this.$refs.regform.validate(valid => {
        if (valid) {
          this.regFirstStep();
         
          // this.regActive = !this.regActive;
          // this.regActiveTwo = !this.regActiveTwo;
          // this.user_phone_exists = '';

          // document.querySelectorAll(".place__holder").forEach(holder => {
          //   holder.style.transform = "translateY(100%)";
          // })
           this.userError3 = false;
            this.wrong_code = false;
        } else {
          console.log("error submit!!");
          this.userError3 = true;
          return false;
        }
      });
    },

    register2() {
      this.$refs.regform2.validate(valid => {
        if (valid) {
          console.log("correct");
          // mark
         
          this.regSecondStep();
          // this.authActive = true;
          // this.regActive = false;
          // this.regActiveTwo = false;
          // this.forgotActive = false;




          // this.user_phone_exists = '';
          // if (this.$refs.regform2) this.$refs.regform2.resetFields();
          // if (this.$refs.regform) this.$refs.regform.resetFields();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    regFirstStep: async function() {
      let data = {};
      data.name = this.regform.inputregname;
      data.lastname = this.regform.inputlastname;
      data.email = this.regform.inputregmail;
      data.phone = this.regform.inputphone;

      data.agreeChecked = this.regform.checked;

      let tmp = await this.$fn.postData("user/VerifyRegistrationParams", data);

      if (
        tmp.data &&
        tmp.data[0] &&
        tmp.data[0].email &&
        tmp.data[0].email === "User With this email exists"
      ) {
        console.log("heeeeeeey");
        this.regActive = true;
        this.regActiveTwo = false;
        this.email_exists = true;
      } else if( 
        tmp.data &&
        tmp.data[0] &&
        tmp.data[0].phone &&
        tmp.data[0].phone === "User With this phone exists"

      ){
            console.log("heeeeeeey");
            console.log(tmp)
              document.querySelectorAll(".place__holder").forEach(holder => {
            holder.style.transform = "translateY(0%)";
          })
        this.regActive = true;
        this.regActiveTwo = false;
        
      }
      
      
      else {
        this.regActive = false;
        this.regActiveTwo = true;
        if (this.email_exists) this.email_exists = false;
        this.user_phone_exists = '';
        this.sms_id = tmp.data.sms_id;
        data.sms_id = this.sms_id;
      }
      if(tmp.data[0] && tmp.data[0].phone){
            this.user_phone_exists =  tmp.data[0].phone;
      }  
   
      console.log(tmp); //User With this email exists
    },

    regSecondStep: async function() {
      let data = {};
      data.name = this.regform.inputregname;
      data.lastname = this.regform.inputlastname;
      data.email = this.regform.inputregmail;
      data.phone = this.regform.inputphone;

      data.agreeChecked = this.regform.checked;
      data.password = this.regform2.pass;
      data.passConfirm = this.regform2.passconfirm;
      data.code = this.regform2.code;
        data.sms_id = this.sms_id;

      let tmp = await this.$fn.postData("user/Register", data);
      if (tmp.status == 200) {
        // this.user_token = tmp.data.access_token;
        console.log(tmp.data.access_token);
        let userdata = await this.$fn.postData("user/getuserdata", {
          token: tmp.data.access_token
          
        });

        
        localStorage.userToken = tmp.data.access_token;
        this.$store.commit("main/getUser", userdata.data);
        this.openSignModal();
        console.log(this.$store.state.main.userData);
      }

      if( tmp.status == 201){
          this.wrong_code = true;
          console.log(this.wrong_code)
          console.log("heeeeeeeey")
        } else {
          this.authActive = true;
          this.regActive = false;
          this.regActiveTwo = false;
          this.forgotActive = false;
          this.wrong_code = false;
        }

      // console.log(this.regform2)
      console.log(tmp)
    },

    resend: async function() {
      let data = {};
      data.phone = this.regform.inputphone;

      data.verify = true;

      let tmp = await this.$fn.postData("user/ResendNotification", data);
      console.log(tmp.data.sms_id);
      this.sms_id = tmp.data.sms_id;
      data.sms_id = this.sms_id;
      // console.log(data)
    },

    login: async function() {
      let data = {};
      data.password = this.authform.inputpass;
      data.email = this.authform.inputmail;
      let tmp = await this.$fn.postData("user/login", data);
      if (tmp.status === 201) {
        this.userError = true;
      } else {
        this.userError = false;
      }
      localStorage.userToken = tmp.data.access_token;
      let userdata = await this.$fn.postData("user/getuserdata", {
        token: tmp.data.access_token
      });
      this.$store.commit("main/getUser", userdata.data);
      this.openSignModal();
      console.log(data);
      console.log(tmp);
    }

    // async authFB(){
    //          let data = {};
    //     data.password = this.authform.inputpass;
    //     data.email = this.authform.inputmail;
    //     let tmp =  await this.$fn.postData('source/api/fb/redirect',data);
    //       // localStorage.userToken = tmp.data.access_token;
    //       // let userdata = await this.$fn.postData('user/getuserdata', {token:tmp.data.access_token});
    //       //   this.$store.commit("main/getUser", userdata.data);
    //         console.log(tmp)
    // },

    // async authGoogle(){

    // }
  }
};
</script>

<style lang="scss">
.forgot_success_message{
  display: inline-block;
  margin-top: 70px;
  color: #bacb32;
  @media (max-width: 413px){
    font-size: 16px;
  }
}
.sign-modal-wrapper .el-input__inner {
  width: 100%;
}
.sign-modal-wrapper .err input {
  border-bottom: 2px solid #FF6414;
}
.sign-modal-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 660px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 34px;
  //padding-bottom: 55px;
  z-index: 999999999;
  background-color: #03301f;
  box-shadow: -5px 0 30px rgba(16, 24, 32, 0.1);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .auth-wrapper,
  .reg-wrapper {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .auth-wrapper {
    .or {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 19.5px;
      span {
        color: white;
      }
    }
  }
  .err-block {
    margin-bottom: 20px;
  }

  &::-webkit-scrollbar {
    position: absolute;
    right: 0;
    top: 0;
    width: 5px;
    cursor: pointer;
  }
  &::-webkit-scrollbar-track {
    background-color: white;
    cursor: pointer;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bacb32;
    border-radius: 10px;
    cursor: pointer;
  }
  .sign-modal-inner {
    position: relative;
    padding-left: 25px;
    padding-right: 25px;
  }
  .social-sign-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 55px;
  }
  .google-btn,
  .fb-btn {
    width: 260px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    transition: 0.4s;
    cursor: pointer;
    span {
      margin-left: 10px;
      color: white;
      transition: 0.4s;
    }
    svg path {
      transition: 0.4s;
    }
    @media (min-width: 1024px) {
      &:hover {
        background-color: white;
        span {
          color: #03301f;
        }
        svg path {
          fill: #03301f;
        }
      }
    }
  }

  h2 {
    color: #bacb32;
    margin-bottom: 55px;
  }
  .close-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 55px;
    span {
      color: white;
    }
  }
  .close-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.4s;
    will-change: transform;
    svg path {
      fill: white;
    }
    @media (min-width: 1024px) {
      &:hover {
        transform: scale(1.1) rotate(-2deg);
      }
    }
    svg {
      margin-right: 9.6px;
    }
  }
  .el-input__inner {
    font-size: 21px;
    background: transparent;
    font-family: "FiraGO-BoldItalic";

    padding-bottom: 13px;
    //  border-color: rgba(255, 255, 255, 0.3);
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    border-radius: 0;
    outline-width: 0 !important;
    height: 40px;
    color: white;
    outline: 0 !important;
    &:focus {
      outline: 0 !important;
      outline-width: 0 !important;
    }
    -moz-appearance: textfield;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &:-ms-input-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-moz-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
  .el-form-item__error{
    color:#FF6414;
    font-family: "FiraGO-Italic";
  }
  .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus{
    border-color:#FF6414;
  }



  .sign-modal-footer {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding-top: 89px;
    padding-bottom: 55px;
    span {
      &:nth-child(2) {
        margin-bottom: 35px;
      }
      &:nth-child(1),
      &:nth-child(3) {
        color: rgba(255, 255, 255, 0.7);
      }
      &:nth-child(2),
      &:nth-child(4) {
        color: #bacb32;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .signinmail {
    margin-bottom: 21px;
  }
  .signinpass {
    // margin-top: 24px;
    margin-bottom: 21px;
  }

  .auth-btn {
    background: url("../../assets/img/authbtnbg.png");
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    width: 245px;
    height: 58px;
    cursor: pointer;
    margin-top: 55px;
    transition: 0.4s;
    will-change: transform;
    span {
      color: #03301f;
    }
    @media (min-width: 1024px) {
      &:hover {
        transform: scale(1.1) rotate(-2deg);
      }
    }
  }
  .forgot-pass {
    span {
      color: white;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .reg-wrapper {
    position: relative;
    .or {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 19.5px;
      span {
        color: white;
      }
    }
  }
  .tool-tip-row {
    display: flex;
    align-items: center;
    span {
      color: white;
      margin-left: 6px;
    }
  }
  .ag-checkbox-wrapper{
    display: flex;
    align-items: center;
     span{
          color: white;
      font-family: "FiraGO-Italic";
      font-size: 14px;
    &.f-16{
      margin-left: 10px;
      margin-top: 10px;
    }
     }
   
    a {
       margin-top: 6px;
      color: #fdcf18;
      font-family: "FiraGO-Italic";
      font-size: 13px;
      margin-left: 7px;
      text-decoration: underline;
    }
  }
  .el-form-item__error{
    min-width: 300px;
    @media (max-width: 350px){
      max-width: 210px;
      min-width: 210px;
    }
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    margin-top: 35px;
    color: white;
    font-family: "FiraGO-Italic";
    font-size: 13px;
    &__input.is-checked + .el-checkbox__label {
      color: white;
      font-family: "FiraGO-Italic";
    }
    &__label {
      color: white;
      font-family: "FiraGO-Italic";
    }
    a {
      color: #fdcf18;
      font-family: "FiraGO-Italic";
      font-size: 13px;
      text-decoration: underline;
    }
    &__inner {
      background-color: transparent;
      border: none;
      background: url("../../assets/img/checkbox.png");
      background-size: cover;
      width: 24px;
      height: 24px;
      &::after {
        display: none;
      }
    }
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: transparent;
    background: url("../../assets/img/checkboxchecked.png");
    background-size: cover;
    width: 24px;
    height: 24px;
  }

  .sms-sent {
    border: white 1px solid;
    background-color: rgba(255, 255, 255, 0.2);
    width: 550px;
    height: 95px;
    padding: 21px 34px 21px 34px;
    display: flex;
    margin-bottom: 13px;
    svg {
      margin-right: 10px;
    }
    span {
      color: white;
    }
  }
  .resend {
    text-decoration: underline;
    color: white;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    width: 100%;
    .sign-modal-inner {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.place__holder{
  color: rgba(255, 255, 255, 0.6);
  transform: translateY(100%);
  transition: .5s;
  &.err{
    color: #FF6414;
  }
}
.from-right-enter-active {
  transition: all 0.9s cubic-bezier(0.33, 1, 0.68, 1);
}
.from-right-leave-active {
  transition: all 0.9s cubic-bezier(0.32, 0, 0.67, 0);
}
.from-right-enter {
  transform: translateX(100%);
}
.from-right-leave-to {
  transform: translateX(100%);
}

// .sign-modal-wrapper .el-input.is-active .el-input__inner, .el-input__inner:focus{
//   border-color: hsla(0,0%,100%,.3) !important;
// }
</style>
